import { useRequest } from './chunk-SNCLEEAV.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';

// src/listen/query-hooks/playlists.ts
var playlistsQuery = graphql(
  /* GraphQL */
  `
  query ListenPlaylists {
    playlist(
      where: { site: { _eq: "listen" } }
      order_by: { createdAt: desc }
    ) {
      id
      title
      slug
    }
  }
`
);
var useLoadPlaylists = () => {
  const { isSignedIn, getAccessToken } = useAuthContext();
  const { data, isLoading, error } = useRequest({
    queryKey: ["listen-playlists", isSignedIn],
    getAccessToken: isSignedIn ? getAccessToken : void 0,
    document: playlistsQuery
  });
  return {
    playlists: data ? data.playlist : [],
    isLoading,
    error
  };
};

export { useLoadPlaylists };
//# sourceMappingURL=chunk-MVQJSB6K.mjs.map
//# sourceMappingURL=chunk-MVQJSB6K.mjs.map